<template>
  <div class="main-wrapper-container create-new-service">
    <header-title :main-title="mainTitle"></header-title>

    <title-slot
        is-active-big-title="big"
        key="title"
        title="Название"
    >
      <input-main :active-textarea="true"
                  :rules="rulesRequired"
                  @changeValue="value => updateInput(value)"
                  :value="form.name"
                  :info-input="inputInfoName"
      />
    </title-slot>

    <title-slot
        is-active-big-title="big"
        key="description"
        title="Описание"
    >
      <input-main :active-textarea="true"
                  @changeValue="value => form.description = value.value"
                  :value="form.description"
                  :info-input="inputInfoDescription"
      />
    </title-slot>

    <title-slot class="editor-wrapper" title="Контент (редактор)">
      <editor-container
          :active-item="form.content"
          @changeEditorContent="value => form.content = value"
      />
    </title-slot>

    <tags-block
        @changeTags="tags => form.tags = tags"
        tags-title="Теги"
        @closeTags="tag => removeTag(tag)"
        :tags-out="form.tags"
    />

    <!-- URL -->
    <title-slot :is-active-big-title="true" :title="inputInfoUrl.title">
      <input-main
          :active-textarea="false"
          @changeValue="value => form.url = value.value"
          :value="form.url"
          :info-input="inputInfoUrl"
      />
    </title-slot>

    <!-- SEO -->
    <title-slot :is-active-big-title="true" title="SEO">
      <input-main
          :active-textarea="true"
          :rules="rulesRequired"
          @changeValue="value => form.metaTitle = value.value"
          :value="form.metaTitle"
          :info-input="inputInfoMetaTitle"
      />
      <input-main
          :active-textarea="true"
          :rules="rulesRequired"
          @changeValue="value => form.metaDescription = value.value"
          :value="form.metaDescription"
          :info-input="inputInfoMetaDescription"
      />
      <input-main
          :active-textarea="true"
          :rules="rulesRequired"
          @changeValue="value => form.keywords = value.value"
          :value="form.keywords"
          :info-input="inputInfoKeywords"
      />
    </title-slot>

    <button-main
        @click="saveInfo"
        :disabled="isDisabledButton"
    >
      Сохранить
    </button-main>
  </div>
</template>

<script>
import InputMain from "@/components/shared/input/InputMain.vue";
import RulesMixin from "@/mixins/rules.mixin";
import HeaderTitle from "@/components/entities/HeaderTitle.vue";
import TitleSlot from "@/components/entities/TitleSlot.vue";
import TagsBlock from "@/components/entities/CRUDBlock/TagsBlock.vue";
import ButtonMain from "@/components/shared/buttons/ButtonMain.vue";
import EditorContainer from "@/components/entities/EditorContainer.vue";
import {api} from "@/middleware/api";

export default {
  name: "ServiceForm",
  components: {ButtonMain, TagsBlock, TitleSlot, HeaderTitle, InputMain, EditorContainer},
  mixins: [RulesMixin],
  data() {
    return {
      mainTitle: 'Новая услуга',
      form: {
        name: '',
        description: '',
        content: '',
        tags: [],
        url: '',
        metaTitle: '',
        metaDescription: '',
        keywords: '',
        date: '',
        relatedServices: [],
      },
    }
  },
  async created() {
    const id = this.$route.params.id;
    if (id) {
      this.mainTitle = "Редактор услуги";
      this.IS_GLOBAL_LOADING(true)
      const { data } = await api.dashboard.adminCasesControllerFindOne(id)
      if (data) {
        this.form = {
          ...this.form,
          name: data.translations[0].title,
          description: data.translations[0].subtitle || '',
          content: data.translations[0].content || '',
          tags: data.tags.map( e => e.id ),
          url: data.url || '',
          metaTitle: data.seoTitle || '',
          metaDescription: data.seoDescriptions || '',
          keywords: data.keyWords || '',
        };
      }
      this.IS_GLOBAL_LOADING(false)
    } else {
      this.mainTitle = "Новая услуга";
    }
  },
  computed: {
    isDisabledButton() {
      return !this.form.name.trim() || this.form.tags.length === 0
    },
    inputInfoName() {
      return {
        maxLength: 50,
        placeholder: 'Введите текст',
      }
    },
    inputInfoDescription() {
      return {
        maxLength: 500,
        placeholder: 'Введите текст',
      }
    },
    inputInfoUrl() {
      return {
        placeholder: 'Введите URL страницы',
        type: 'big',
        title: 'URL страницы',
      }
    },
    inputInfoMetaTitle() {
      return { maxLength: 70, placeholder: 'Meta Title' }
    },
    inputInfoMetaDescription() {
      return { maxLength: 170, placeholder: 'Meta Description' }
    },
    inputInfoKeywords() {
      return { maxLength: 255, placeholder: 'Keywords' }
    }
  },
  methods: {
    async createItem() {
      try {
        await api.dashboard.adminCasesControllerCreate({
          translations: [
            {
              "title": this.form.name,
              "subtitle": this.form.description || '',
              "content": this.form.content || '',
              "langCode": "RU"
            }
          ],
          url: this.form.url,
          seoTitle: this.form.metaTitle,
          seoDescriptions: this.form.metaDescription,
          keyWords: this.form.keywords,
          publishedAt: new Date().toISOString(),
          status: "PUBLISHED",
          tagIds: this.form.tags
        })
        this.alertSuccess('Контент сохранен!')
        this.$router.push({
          name: 'services'
        })
      }
      catch (e) {
        console.log('error', e)
        this.alertError('Что-то пошло не так!')
      }
    },
    async editItem(id) {
      try {
        await api.dashboard.adminCasesControllerUpdate(id, {
          translations: [
            {
              "title": this.form.name,
              "subtitle": this.form.description || '',
              "content": this.form.content || '',
              "langCode": "RU"
            }
          ],
          url: this.form.url,
          seoTitle: this.form.metaTitle,
          seoDescriptions: this.form.metaDescription,
          keyWords: this.form.keywords,
          publishedAt: new Date().toISOString(),
          status: "PUBLISHED",
          tagIds: this.form.tags
        })
        this.alertSuccess('Контент сохранен!')
        this.$router.push({
          name: 'services'
        })
      }
      catch (e) {
        console.log('error', e)
        this.alertError('Что-то пошло не так!')
      }
    },
    async saveInfo() {
      const id = this.$route.params.id
      if (id) {
        await this.editItem(id)
      } else {
        await this.createItem()
      }
    },
    removeTag(item) {
      this.form.tags = this.form.tags.filter(e => e !== item)
    },
    updateInput(data) {
      this.form.name = data.value
    },
  }
}
</script>

<style scoped lang="scss">
.create-new-service{
  max-width: 1000px;
  width: 100%;
  overflow-x: hidden;

  .block-container {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
  }

  .title-slot-container {
    width: 100%;
    max-width: 100%;
    row-gap: 20px;
  }

  :deep(.v-textarea) {
    width: 100%;
    max-width: 100%;

    .v-field {
      width: 100%;
      max-width: 100%;
    }

    .v-field__input {
      width: 100% !important;
      max-width: 100% !important;
    }

    textarea {
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box;
      word-wrap: break-word;
      overflow-wrap: break-word;
      white-space: pre-wrap;
    }
  }

  :deep(.v-input) {
    width: 100%;
    max-width: 100%;
  }
}
</style>